import request from '../request/request';
import {handleRes} from '../utils/utils';


interface HandleResInterface {
    success: any,
    fail: any,
}

const GETEmployee = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETEmployee(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};

const POSTEmployee = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTEmployee(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};

const PUTEmployee = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.PUTEmployee(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const DELETEEmployee = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.DELETEEmployee(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};
const GETGetMqttConfig = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.GETGetMqttConfig(params,);

        const handleParams = {}
        if(res.code !== 200 && res.code !== 401){
          // @ts-ignore
          handleParams.failMes = res.msg
        }

        const result = handleRes(res, handleParams);
        resolve(result);
    });
};
// 修改密码
const postAccUpdatePwd = (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
        const res = await request.POSTAccUpdatePwd(params,);
        const result = handleRes(res, {
            failMes: res.msg,
        });
        resolve(result);
    });
};


export {
    GETEmployee,
    POSTEmployee,
    PUTEmployee,
    DELETEEmployee,
    GETGetMqttConfig,
    postAccUpdatePwd
};
